import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const getCardList = async (userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "getCustCardAssignedList",
      dat: {
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const assignPhysicalCard = async (cardNo, userid, userpi, pin, agentid, firstname, lastname, email) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "assignPhysicalCard",
      dat: {
        cardNo: cardNo,
        userid: userid,
        userpi: userpi,
        pin: pin,
        agentid: agentid,
        firstname: firstname,
        lastname: lastname,
        email: email,

      },
    });

    // console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const activateCard = async (cardID, userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "activateCard",
      dat: {
        cardID: cardID,
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const deactivateCard = async (cardID, userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "inactivateCard",
      dat: {
        cardID: cardID,
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const unassignPhysicalCard = async (cardID, userid) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "unassignPhysicalCard",
      dat: {
        cardID: cardID,
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateCardStatus = async (cardID, userid, cardStatus) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "updateCardStatus",
      dat: {
        cardID: cardID,
        userid: userid,
        cardStatus: cardStatus,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const assignExternalCard = async (
  cardNo,
  userid,
  pid,
  friendlyname,
  purposeofaccount,
  servicefeeexmpted,
  email,
  pin,
  agentID,
  agentFirstName,
  agentLastName,
  parentuserid,
  isOperator
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "addExternalCard",
      dat: {
        cardNo: cardNo,
        userid: userid,
        pid: pid,
        friendlyname: friendlyname,
        purposeofaccount: purposeofaccount,
        servicefeeexmpted: servicefeeexmpted,
        email: email,
        pin: pin,
        agentID: agentID,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        parentuserid: parentuserid,
        isOperator: isOperator,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listCards = async () => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "listCards",
      dat: { ...sessionData },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const approveCard = async (
  cardnumber,
  agentID
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "approveCard",
      dat: {
        cardnumber: cardnumber,
        agentID: agentID,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const rejectCard = async (
  cardnumber,
  agentID
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "rejectCard",
      dat: {
        cardnumber: cardnumber,
        agentID: agentID,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};


export const getCardHistory = async (
  cardnumber,
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "getCardHistory",
      dat: {
        cardnumber: cardnumber,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserData = async (
  changedBy,
  assignedUserID
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "getUserData",
      dat: {
        changedBy: changedBy,
        assignedUserID: assignedUserID,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateMastercardStatus = async (
  agentID,
  userpiid,
  firstname,
  lastname,
  addressline1,
  addressline2,
  city,
  state,
  country,
  zipcode,
  cardstatus
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "UpdateExternalCardDetails2",
      dat: {
        agentID: agentID,
        userpiid: userpiid,
        firstname: firstname,
        lastname: lastname,
        addressline1: addressline1,
        addressline2: addressline2,
        city: city,
        state: state,
        country: country,
        zipcode: zipcode,
        cardstatus: cardstatus,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateLostDamagedCardStatus = async (cardID, userid, cardStatus, selectedCardNo) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "updateLostDamagedCardStatus",
      dat: {
        cardID: cardID,
        userid: userid,
        cardStatus: cardStatus,
        cardnumber: selectedCardNo,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getPIExternalInfo4 = async (location, userID, pid, pin, optrequired, currcode) => {
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "getPIExternalInfo4",
      dat: {
        location: location,
        userID: userID,
        pid: pid,
        pin: pin,
        optrequired: optrequired,
        currcode: currcode,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getPIExternalInfo8 = async (location, userID, pid, pin, optrequired, currcode) => {
  try {
    const data = JSON.stringify({
      svc: "card_services",
      pid: "getPIExternalInfo8",
      dat: {
        location: location,
        userID: userID,
        pid: pid,
        pin: pin,
        optrequired: optrequired,
        currcode: currcode,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const straightPayment = async (cardnumber, currcode, amount, merchantsurgcharge, merchantrefno, accountentrycomment, externalrefid, atmaddress, pin, agentid) => {
  try {
    const data = JSON.stringify({
      svc: "forcefully_payment_processing",
      pid: "straightPayment",
      dat: {
        cardnumber: cardnumber,
        currcode: currcode,
        amount: amount,
        merchantsurgcharge: merchantsurgcharge,
        merchantrefno: merchantrefno,
        accountentrycomment: accountentrycomment,
        externalrefid: externalrefid,
        atmaddress: atmaddress,
        pin:pin,
        agentid:agentid
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};